import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
} from '@material-ui/core';
import { AppState } from '../../state/MyStateProvider';
import Dashboard3Drawers from '../dashboard-3-drawers/Dashboard3Drawers';
import {
  APP_STATE_ACTION_TYPE_USER_LOCALE,
  APP_STATE_ACTION_TYPE_USE_SYS_LOCALE,
  APP_STATE_ACTION_TYPE_USER_THEME,
  APP_STATE_ACTION_TYPE_USE_SYS_THEME,
  APP_STATE_ACTION_TYPE_USER_FONT,
  APP_STATE_ACTION_TYPE_USER_FONT_SIZE,
} from '../../state/seed-states';
import { getSysLocale } from '../../intl/intl-helpers';
import useSystemTheme from '../../theme/theme-helpers';
import SeedFontSettings from './SeedFontSettings';
import SeedThemeSettings from './SeedThemeSettings';
import SeedLocaleSettings from './SeedLocaleSettings';
import { defaultSettingsSettingablesPropTypes, settingsSettingablesPropTypes } from './settings-page-prop-types';
import { drawerRoutesPropTypes, dashboard3DrawersIconsPropTypes } from '../dashboard-3-drawers/d3d-prop-types';
import SeedAuthenticationRepository from '../../repository/SeedAuthenticationRepository';
import { seedSupportedThemes } from '../../theme/seed-themes';
import { seedSupportedFonts, seedSupportedFontSizes } from '../../font/seed-fonts';
import { seedSupportedLocales } from '../../intl/seed-intl';
import seedDrawerRoutes from '../../route/seed-drawer-routes';
import seedLogo from '../../images/logo.svg';
import { seedDashboard3DrawersIcons } from '../../icon/seed-icons';

const SeedSettingsPage = (props) => {
  const {
    AuthenticationRepository,
    drawerRoutes,
    supportedLocales,
    supportedThemes,
    supportedFonts,
    supportedFontSizes,
    settingables,
    applicationName,
    logo,
    icons,
    popoverMenus,
  } = props;
  const { state, dispatch } = React.useContext(AppState);

  const sysLocale = getSysLocale();
  const useSysLocale = state[APP_STATE_ACTION_TYPE_USE_SYS_LOCALE];
  const locale = state[APP_STATE_ACTION_TYPE_USER_LOCALE];

  const sysTheme = useSystemTheme();
  const useSysTheme = state[APP_STATE_ACTION_TYPE_USE_SYS_THEME];
  const theme = state[APP_STATE_ACTION_TYPE_USER_THEME];

  const font = state[APP_STATE_ACTION_TYPE_USER_FONT];
  const fontSize = state[APP_STATE_ACTION_TYPE_USER_FONT_SIZE];

  const handleChangeSettings = (type, value, valueType) => {
    dispatch({
      type,
      value,
      valueType,
    });
  };

  return (
    <Dashboard3Drawers
      titleId="seed.settings.title"
      routes={drawerRoutes}
      applicationName={applicationName}
      logo={logo}
      icons={icons}
      AuthenticationRepository={AuthenticationRepository}
      useBackButton
      popoverMenus={popoverMenus}
    >
      {
        settingables[APP_STATE_ACTION_TYPE_USE_SYS_LOCALE]
        || settingables[APP_STATE_ACTION_TYPE_USER_LOCALE]
          ? (
            <SeedLocaleSettings
              sysLocale={sysLocale}
              useSysLocale={useSysLocale}
              locale={locale}
              supportedLocales={supportedLocales}
              onChangeSettings={handleChangeSettings}
              settingables={settingables}
            />
          ) : ''
      }
      {
        (settingables[APP_STATE_ACTION_TYPE_USE_SYS_LOCALE]
        || settingables[APP_STATE_ACTION_TYPE_USER_LOCALE])
        && (settingables[APP_STATE_ACTION_TYPE_USE_SYS_THEME]
        || settingables[APP_STATE_ACTION_TYPE_USER_THEME]
        || settingables[APP_STATE_ACTION_TYPE_USER_FONT]
        || settingables[APP_STATE_ACTION_TYPE_USER_FONT_SIZE])
          ? <Box mt={2} /> : ''
      }
      {
        settingables[APP_STATE_ACTION_TYPE_USE_SYS_THEME]
        || settingables[APP_STATE_ACTION_TYPE_USER_THEME]
          ? (
            <SeedThemeSettings
              sysTheme={sysTheme}
              useSysTheme={useSysTheme}
              theme={theme}
              supportedThemes={supportedThemes}
              onChangeSettings={handleChangeSettings}
              settingables={settingables}
            />
          ) : ''
      }
      {
        (settingables[APP_STATE_ACTION_TYPE_USE_SYS_THEME]
        || settingables[APP_STATE_ACTION_TYPE_USER_THEME])
        && (settingables[APP_STATE_ACTION_TYPE_USER_FONT]
        || settingables[APP_STATE_ACTION_TYPE_USER_FONT_SIZE])
          ? <Box mt={2} /> : ''
      }
      {
        settingables[APP_STATE_ACTION_TYPE_USER_FONT]
        || settingables[APP_STATE_ACTION_TYPE_USER_FONT_SIZE]
          ? (
            <SeedFontSettings
              font={font}
              supportedFonts={supportedFonts}
              fontSize={fontSize}
              supportedFontSizes={supportedFontSizes}
              onChangeSettings={handleChangeSettings}
              settingables={settingables}
            />
          ) : ''
      }
    </Dashboard3Drawers>
  );
};

SeedSettingsPage.propTypes = {
  AuthenticationRepository: PropTypes.func,
  drawerRoutes: drawerRoutesPropTypes,
  supportedLocales: PropTypes.arrayOf(PropTypes.string),
  supportedThemes: PropTypes.arrayOf(PropTypes.string),
  supportedFonts: PropTypes.arrayOf(PropTypes.string),
  supportedFontSizes: PropTypes.arrayOf(PropTypes.number),
  settingables: settingsSettingablesPropTypes,
  applicationName: PropTypes.string,
  logo: PropTypes.string,
  icons: dashboard3DrawersIconsPropTypes,
};

SeedSettingsPage.defaultProps = {
  AuthenticationRepository: SeedAuthenticationRepository,
  drawerRoutes: seedDrawerRoutes,
  supportedLocales: seedSupportedLocales,
  supportedThemes: seedSupportedThemes,
  supportedFonts: seedSupportedFonts,
  supportedFontSizes: seedSupportedFontSizes,
  settingables: defaultSettingsSettingablesPropTypes,
  applicationName: 'react-seed',
  logo: seedLogo,
  icons: seedDashboard3DrawersIcons,
};

export default SeedSettingsPage;
